(function() {
  const fitLink = document.querySelector('.product__fitHeaderLink');
  const body = document.querySelector('body');
  const productPageWrapper = document.querySelector('.product.product--opacity');
  const colorTitle = document.querySelector('.product__colorPickerTitle span');
  const colorsListArray = document.querySelectorAll('.product__colorPickerList a');
  const tabsArray = document.querySelectorAll('.product__tabsDescription');
  const tooltiptitles = document.querySelectorAll('.product__colorPickerTitleWrapper');
  const productSlides = document.querySelectorAll('.product__wrapper .customSlider__item');
  const zoomWindow = document.querySelector('.zoomWindow');
  const zoomImage = document.querySelector('.zoomWindow .zoomWindow__image');
  const closeButton = document.querySelector('.zoomWindow__button--close');
  const zoomWindowWrapper = document.querySelector('.zoomWindow__wrapper');
  const collapseSections = document.querySelectorAll('.productCollapse');
  const productFormInfo = document.querySelector('.product__formInfo');
  const colorPickerDropdownTitles = document.querySelectorAll('.product__colorPickerDropdownTitle, .product__colorPickerDropdown--toggler');
  const pageWrapper = document.querySelector('.wrapper');
  const copyLinks = document.querySelectorAll('.product__earlyAccess a[href="#copy"]');
  const emptyVariantLink = document.querySelectorAll('.product__lacesTabsLinksItem--empty');
  const atcText = document.querySelector('#add-to-cart-text');
  const tabsHeightArray = [];
  const availableProduct = document.querySelector('.product__swatchesItemLabel:not(.product__swatchesItemLabel--disabled) label');
  const overlay = document.querySelector('.product__wrapper--overlay');
  const tabHandlers = document.querySelectorAll('.js-product-tab-toggler');
  const productButton = document.querySelector('.product__buttons');
  const productButtonWrapper = document.querySelector('.product__button-wrapper');

  if (atcText) {
    const config = { characterData: true, subtree: true, childList: true };

    const callback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          if (atcText.textContent === 'Pre-order') {
            const swatchesItemLabels = document.querySelectorAll('.product__swatches .product__swatchesItemLabel--disabled');

            swatchesItemLabels.forEach((label) => {
              label.classList.remove('product__swatchesItemLabel--disabled');
            });
          }
        }
      }
    };

    const observer = new MutationObserver(callback);

    observer.observe(atcText, config);
  }

  function toggleTooltip(target) {
    if (target.matches('.product__colorPickerTitleWrapper--active')) {
      target.classList.remove('product__colorPickerTitleWrapper--active');
    } else {
      target.classList.add('product__colorPickerTitleWrapper--active');
    }
  }

  function openZoomWindow(e) {
    const productImages = document.querySelectorAll('.product__gallery picture');
    const activeImage = e.currentTarget.querySelector('picture');
    const zoomList = document.querySelector('.zoomWindow__list');
    const zoomImage = document.querySelector('.zoomWindow__image');

    if (zoomList && window.innerWidth > 1279) {
      let imagesMarkup = '';

      productImages.forEach((image) => {
        imagesMarkup += image.outerHTML;
      });

      zoomList.innerHTML = imagesMarkup;
      zoomWindow.classList.add('zoomWindow--active');
      body.classList.add('body--overflow');

      const insertedImage = document.querySelector(`.zoomWindow__list picture[data-id="${activeImage.dataset.id}"] img`);
      const zoomListWrapper = document.querySelector('.zoomWindow__wrapper');

      zoomListWrapper.scrollTo({
        top: insertedImage.offsetTop - (window.innerHeight / 2) + (insertedImage.offsetHeight / 2),
      });
    } else if (zoomImage && window.innerWidth < 1279) {
      const zoomWindowWrapper = document.querySelector('.zoomWindow__wrapper');

      zoomImage.innerHTML = activeImage.outerHTML;
      zoomWindow.classList.add('zoomWindow--active');
      body.classList.add('body--overflow');

      const insertedImage = document.querySelector('.zoomWindow .zoomWindow__image img');

      zoomWindowWrapper.scrollLeft = `${(insertedImage.offsetWidth - window.innerWidth) / 2}`;
      zoomWindowWrapper.scrollTop= `${(insertedImage.offsetHeight - window.innerHeight) / 2}`;
    }
  }

  function closeZoomWindow() {
    zoomWindow.classList.remove('zoomWindow--active');
    body.classList.remove('body--overflow');
  }

  function collapseContent() {
    if (window.pageYOffset >= 10) {
      productFormInfo.classList.add('product__formInfo--collapse');

      collapseSections.forEach((section) => {
        section.classList.add('productCollapse--active');
        section.style.maxHeight = `0px`;
      });
    } else {
      productFormInfo.classList.remove('product__formInfo--collapse');

      collapseSections.forEach((section) => {
        section.classList.remove('productCollapse--active');
        section.style.maxHeight = `${section.scrollHeight}px`;
      });
    }
  }

  function toggleDropdown(e) {
    const currentItem = e.currentTarget.closest('.product__dropdownItem');
    const currentContent = currentItem.querySelector('.product__dropdownItemContent');

    currentItem.classList.toggle('product__dropdownItem--active');

    if (currentItem.matches('.product__dropdownItem--active')) {
      currentContent.style.height = `${currentContent.scrollHeight}px`;
    } else {
      currentContent.style.height = '0px';
    }

    if (document.querySelector('.product__dropdownItem--active')) {
      stickyWrapper.classList.add('product__wrapper--stickyPadding');
    } else {
      stickyWrapper.classList.remove('product__wrapper--stickyPadding');
    }
  }

  function toggleOverlay() {
    const body = document.querySelector('body');

    if (window.innerWidth <= 768) {
      overlay?.classList.toggle('product__wrapper--overlay-active');
      body?.classList.toggle('body--overflow');
    }
  }

  function toggleColorPickerDropdown(e) {
    e.stopPropagation();

    const colorPickerDropdownList = document.querySelector('.product__colorPickerDropdown');
    const overlay = document.querySelector('.product__wrapper--overlay');
    const body = document.querySelector('body');

    colorPickerDropdownList?.classList.toggle('product__colorPickerDropdown--active');

    if (window.innerWidth <= 768 && colorPickerDropdownList) {
      overlay.classList.toggle('product__wrapper--overlay-active');
      body.classList.toggle('body--overflow');
    }
  }

  if (window.innerWidth <= 768) {
    tooltiptitles.forEach(title => {
      title.addEventListener('click', (e) => {
        toggleTooltip(e.currentTarget);
      });
    });
  } else {
    if (collapseSections.length) {
      window.addEventListener('scroll', collapseContent);
    }
  }

  tabsArray.forEach(tab => {
    tabsHeightArray.push(tab.scrollHeight);
  });

  productSlides.forEach((image) => {
    image.addEventListener('click', openZoomWindow);
  });

  closeButton?.addEventListener('click', closeZoomWindow);
  zoomWindowWrapper?.addEventListener('click', closeZoomWindow);

  if (colorTitle) {
    colorsListArray.forEach(color => {
      color.addEventListener('mouseover', event => {
        toggleColor(event);
      });
    });

    colorsListArray.forEach(color => {
      color.addEventListener('mouseleave', event => {
        toggleColor(event);
      });
    });

    function toggleColor(event) {
      let currentColor = event.currentTarget.title,
          currentTitle = event.currentTarget.closest('.product__colorPickerList').querySelector('.product__colorPickerTitle span'),
          colorPickerTitle = event.currentTarget.closest('.product__colorPickerList').querySelector('.product__colorPickerTitle'),
          startColor = event.currentTarget.closest('.product__colorPickerList').querySelector('.product__colorPickerTitle span').dataset.colorTitle;

      if (event.type == 'mouseover') {
        currentTitle.innerText = currentColor;

        if (!colorPickerTitle.classList.contains('product__colorPickerTitle--active')) {
          colorPickerTitle.classList.add('product__colorPickerTitle--active');
        } else {
          colorPickerTitle.classList.remove('product__colorPickerTitle--active');

          setTimeout(() => {
            colorPickerTitle.classList.add('product__colorPickerTitle--active');
          }, 0);
        }
      } else {
        currentTitle.innerText = startColor ? startColor : '';

        if (colorPickerTitle.classList.contains('product__colorPickerTitle--active')) {
          colorPickerTitle.classList.remove('product__colorPickerTitle--active');
        }
      }
    }
  }

  if (fitLink) {
    const closeFitButton = document.querySelector('.product__fitButtonClose');

    function openFitPopUp() {
      let fitContent = document.querySelector('.product__fitContentWrapper'),
          overlap = document.querySelector('.overlap');

      fitContent.classList.add('product__fitContentWrapper--active');
      overlap.classList.add('overlap--active');
      body.classList.add('body--overflow');
    }

    function closeFitPopUp() {
      let fitContent = document.querySelector('.product__fitContentWrapper'),
          overlap = document.querySelector('.overlap');

      fitContent.classList.remove('product__fitContentWrapper--active');
      overlap.classList.remove('overlap--active');
      body.classList.remove('body--overflow');
    }

    fitLink.addEventListener('click', openFitPopUp);
    closeFitButton.addEventListener('click', closeFitPopUp);
  }

  if (window.innerWidth <= 768) {
    const swiperCloseButtons = document.querySelectorAll('.zoom-toggle__button');

    function closeZoomedImage(event) {
      let activeGallery = document.querySelector('.product__gallery--active');

      if (activeGallery) {
        event.stopPropagation();
        activeGallery.classList.remove('product__gallery--active');
      }
    }

    swiperCloseButtons.forEach(button => {
      button.addEventListener('click', event => {
        closeZoomedImage(event);
      });
    });
  }

  function copyText(e) {
    e.preventDefault();

    const copiedText = '<span><strong>COPIED</strong></span>';
    const currentLink = e.currentTarget;

    navigator.clipboard.writeText(currentLink.innerText).then(() => {
      currentLink.classList.add('product__copiedLink');
      currentLink.insertAdjacentHTML('beforeend', copiedText);

      setTimeout(() => {
        currentLink.classList.remove('product__copiedLink');
        currentLink.querySelector('span').remove();
      }, 2000);
    });
  }

  function toggleVariant(e) {
    e.preventDefault();

    const activeVariantsList = document.querySelector('.product__variantsSwatchesList--active');
    const currentVariantList = document.querySelector(`[data-variant-swatch="${e.currentTarget.innerText}"]`);
    const variantsListDescription = document.querySelector(`[data-tab-description="${e.currentTarget.innerText}"]`);
    const activeVariantsListDescription = document.querySelector('.product__variantsTabsDescription--show');
    const activeVariantsTitle = document.querySelector('.product__lacesTabsLinksItem--active');
    const currentVariantListFirstVariant = currentVariantList.querySelector('p');

    activeVariantsList.classList.remove('product__variantsSwatchesList--active');
    currentVariantList.classList.add('product__variantsSwatchesList--active');
    activeVariantsTitle.classList.remove('product__lacesTabsLinksItem--active');
    e.currentTarget.classList.add('product__lacesTabsLinksItem--active');
    activeVariantsListDescription?.classList.remove('product__variantsTabsDescription--show');
    variantsListDescription?.classList.add('product__variantsTabsDescription--show');
    currentVariantListFirstVariant.click();
  }

  function toggleTab(e) {
    const target = e.currentTarget;
    const activeTitle = document.querySelector('.product__dropdownItem--active');
    const activeDescription = document.querySelector('.product__dropdownItemContent--active');
    const currentDescription = document.querySelector(`[data-content="${target.dataset.tab}"]`);

    if (target.classList.contains('product__dropdownItem--active')) return null;

    activeTitle?.classList.remove('product__dropdownItem--active');
    activeDescription?.classList.remove('product__dropdownItemContent--active');

    if (currentDescription) {
      target.classList.add('product__dropdownItem--active');
      currentDescription.classList.add('product__dropdownItemContent--active');
    }
  }

  function checkBoxImageSection() {
    const boxImageSection = document.querySelector('.meet-the .meet-the__wrapper');
    const detailsTab = document.querySelector('[data-content="details"]');
    const firstParagraph = detailsTab?.querySelector('p');

    if (boxImageSection && detailsTab && firstParagraph) {
      firstParagraph.classList.add('hidden');
    }
  }

  colorPickerDropdownTitles.forEach((title) => {
    title.addEventListener('click', toggleColorPickerDropdown);
  });

  copyLinks.forEach((link) => {
    link.addEventListener('click', copyText);
  });

  (function() {
    document.addEventListener("DOMContentLoaded", () => {
      productPageWrapper.classList.remove('product--opacity');
    });
  })();

  pageWrapper.addEventListener('click', () => {
    const colorPickerDropdownList = document.querySelector('.product__colorPickerDropdown');
    const overlay = document.querySelector('.productPopUp__overlay');

    colorPickerDropdownList?.classList.remove('product__colorPickerDropdown--active');
    overlay.classList.remove('productPopUp__overlay--active');
  });

  emptyVariantLink.forEach((link) => {
    link.addEventListener('click', toggleVariant);
  });

  overlay.addEventListener('click', toggleOverlay);

  tabHandlers.forEach((tab) => {
    tab.addEventListener('click', toggleTab);
  });

  function checkButtonVisibility() {
    const rect = productButtonWrapper.getBoundingClientRect();
    const isVisible = (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );

    if (isVisible && window.innerWidth <= 768) {
      productButton.classList.remove('product__button--fixed');
    } else {
      productButton.classList.add('product__button--fixed');
    }
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          productButton.classList.remove('product__button--fixed');
        } else {
          productButton.classList.add('product__button--fixed');
        }
      });
    }, {
      threshold: 0.1
    });

    if (productButtonWrapper) {
      observer.observe(productButtonWrapper);
    }
  } else {
    window.addEventListener('scroll', checkButtonVisibility);
    window.addEventListener('resize', checkButtonVisibility);
    checkButtonVisibility();
  }

  if (availableProduct) availableProduct.click();

  document.addEventListener('DOMContentLoaded', () => {
    checkBoxImageSection();
  });
})();
